import { render, staticRenderFns } from "./DeleteProductType.vue?vue&type=template&id=369b6d65"
import script from "./DeleteProductType.vue?vue&type=script&lang=js"
export * from "./DeleteProductType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports